
module.exports = {
	LockMachine: "LockMachine",
	UnlockMachine: "UnlockMachine",
	LockSpyMachine: "LockSpyMachine",
	UnlockSpyMachine: "UnlockSpyMachine",
	GameBtnDown: "GameBtnDown",
	GameBtnUp: "GameBtnUp",
	KickoutClient: "KickoutClient",
	InScore: "InScore",
	OutScore: "OutScore",
	InTrialScore: "InTrialScore",
	OutTrialScore: "OutTrialScore",
	InGuoZhaoScore: "InGuoZhaoScore",
	OutGuoZhaoScore: "OutGuoZhaoScore",
	InSpecialScore: "InSpecialScore",
	OutSpecialScore: "OutSpecialScore",
	Gameplay: "Gameplay",
	BetWinData: "BetWinData",
	UpdateWinAward : "UpdateWinAward",
	BonusState : "BonusState",
	Boosting : "Boosting",

	None: "None"
};